
<template>
  <el-main>
    <!--以下為cc-search-->
    <el-card shadow="never">
      <el-alert title="说明：" type="warning"   :closable="false"> </el-alert>
      <el-alert title="如果员工编号为空，则无法生成导出二维码。" type="warning"   :closable="false"> </el-alert>
      <el-alert title="如果员工编号有修改更新，则需要重新生成导出新的二维码使用。" type="warning"   :closable="false"> </el-alert>
    </el-card>
    <el-card shadow="never" v-if="showSearch">
      <div class="input_box">
        <div class="input">
          <el-cascader
            v-model="paramsTable2.deptId"
            clearable
            :placeholder="language('awaitDaily_dailyList.部门')"
            size="mini"
            :options="classList"
            change-on-select
            :show-all-levels="false"
          >
          </el-cascader>
        </div>
        <el-button @click="doSearch" size="mini" type="primary">{{
          language("awaitDaily_dailyList.搜索")
        }}</el-button>
      </div>
    </el-card>
    <!---->

    <!--以下為cc-table-->
    <cc-table
      :loadData="true"
      :config="configTable"
      :params="paramsTable"
      :refeshParams="refeshTable"
      :autoButtonWidth="true"
      :buttonsWidth="60"
      :select-fun="handleSelect"
      @submit-select="result"
      :submitSelectedButton="false"
      ref="table"
    >
    </cc-table>
    <!---->
  </el-main>
</template>
<script>
import Vue from "vue";

export default {
  data() {
    return {
      showSearch: false,
      searchConfig: [],
      sapNumbering: [],
      refeshTable: -1,
      paramsTable: {},
      paramsTable2: {},
      configTable: {
        api: "mgr/listByPage",
        showPager: true,
        selection: true,
        selectionNoSubmit: true, //不显示确定选择按钮
        selectingResult: true,
        selectionLabel: "导出选中的账号",
        columns: [
          { prop: "account", lable: "账号", minWidth: "150" },
          { prop: "name", lable: "姓名", minWidth: 100 },
          { prop: "roleName", lable: "角色", minWidth: 100 },
          { prop: "deptName", lable: "部门", minWidth: 100 },
          { prop: "categoryName", lable: "类别", minWidth: 100 },
          { prop: "sapNumbering", lable: "员工编号", minWidth: 100 },
          {
            type: "tag",
            prop: "status",
            lable: "状态",
            minWidth: 100,
            options: {
              1: { text: "启用", tagType: "success" },
              2: { text: "冻结", tagType: "danger" },
              3: { text: "已删除", tagType: "danger" },
            },
          },
        ],
        buttons: [],
      },
      classList: [],
      headerButton: {
        btnName: "导出选中的账号",
        onClick: () => {
          let ids = "";
          for (let index = 0; index < this.ids.length; index++) {
            ids += "&userIds=" + this.ids[index];
          }
          window.open(
            "/admin/fsb/employeeinfo/exportEmployeeQrCode?appId=fosber" + ids
          );
        },
      },
      ids: [],
      handleSelect: (row) => {
        return row.sap_numbering !== '';
      },
    };
  },
  methods: {
    //搜索
    doSearch(e) {
      if (this.paramsTable2.deptId && this.paramsTable2.deptId.length > 0) {
        this.paramsTable = {
          deptid: this.paramsTable2.deptId[this.paramsTable2.deptId.length - 1],
        };
      } else {
        this.paramsTable = {};
      }
    },
    initClassList(data) {
      for (let i in data) {
        data[i].label = data[i].fullname;
        data[i].value = data[i].id;
        if (data[i].children.length > 0) {
          this.initClassList(data[i].children);
        } else {
          delete data[i].children;
        }
      }
    },
    getClassList() {
      this.ccRequest
        .do("admin/fsb/workshop/unit/getDeptList", {}, "GET")
        .then((res) => {
          this.classList = res;
          this.initClassList(this.classList);
        });
    },
    result(e) {
      let ids = "", arr = [];
      for (let index = 0; index < e.length; index++) {
        ids += "&userIds=" + e[index];
        arr.push(e[index]);
      }
      window.open(
        "/admin/fsb/employeeinfo/exportEmployeeQrCode?appId=fosber" + ids
      );
    },
  },
  mounted() {
    this.getClassList();
    this.ccRequest.do("validate", {}, "GET").then((res) => {
      if (res.roleTips == "management" || res.roleTips == "administrator") {
        this.showSearch = true;
      }
    });
  },
};
</script>
<style scoped>
.input_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.input {
  margin: 10px 20px 10px 0;
}
</style>
